import { InstituteService } from './../../services/institute/institute.service';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ImageModule } from 'primeng/image';
import { Institute } from '../../models/institute/randomInstituteResponse';
import { ButtonModule } from 'primeng/button';
import { RouterLink, RouterModule } from '@angular/router';

@Component({
  selector: 'app-institute-item',
  standalone: true,
  imports: [ImageModule, CommonModule, ButtonModule, RouterLink, RouterModule],
  templateUrl: './institute-item.component.html',
  styleUrl: './institute-item.component.scss'
})
export class InstituteItemComponent implements OnInit, OnChanges {
  @Input() item: Institute | undefined;
  @Input() index?: number;
  @Input() loading?: boolean;
  @Input() isInstituteSaved: boolean = false;
  /** ISO date string for mentor's custom deadline, e.g. "2025-12-25" */
  @Input() mentorDeadline?: string | null;
  @Input() mentorDeadlineLabel?: string | null;

  daysLeft!: number | null;
  mentorDaysLeft: number | null = null;

  @Output() myInstituteEmitter = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
    this.calculateDaysLeft(this.item!.applicationDeadlineRegularDecision || '');
    this.calculateMentorDaysLeft();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mentorDeadline']) {
      this.calculateMentorDaysLeft();
    }
  }

  toggleMyInstitute(instituteId?: string) {
    this.myInstituteEmitter.emit(instituteId);
  }

  calculateDaysLeft(deadline: string | undefined): void {
    if (!deadline) { this.daysLeft = null; return; }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const target = new Date(deadline);
    if (isNaN(target.getTime())) { this.daysLeft = null; return; }
    this.daysLeft = Math.ceil((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  }

  calculateMentorDaysLeft() {
    if (!this.mentorDeadline) {
      this.mentorDaysLeft = null;
      return;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const target = new Date(this.mentorDeadline);
    if (isNaN(target.getTime())) {
      this.mentorDaysLeft = null;
      return;
    }
    const timeDiff = target.getTime() - today.getTime();
    this.mentorDaysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  }
}
